var _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-123"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-123",
    cx: 250,
    cy: 351.36,
    rx: 236,
    ry: 135.8,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-123"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-123",
    cx: 76.09,
    cy: 382.03,
    rx: 34.64,
    ry: 20,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-123",
    cx: 336.78,
    cy: 421.68,
    rx: 67.32,
    ry: 38.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-123",
    cx: 227.35,
    cy: 352.22,
    rx: 136.01,
    ry: 78.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-123",
    d: "M370.59,396.22l-85.86-49.38a1.33,1.33,0,0,1,0-2.52L381,288.76a4.79,4.79,0,0,1,4.36,0L471,338.23a1.33,1.33,0,0,1,0,2.52L375,396.21A4.84,4.84,0,0,1,370.59,396.22Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-planes--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-planes--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-123"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61.04 152.44 94.66 132.57 71.33 158.52 61.04 152.44",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.66 132.57 57.11 148.27 46.83 142.19 94.66 132.57",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.11 148.27 59.4 157.94 61.04 152.44 94.66 132.57 57.11 148.27",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.11 148.27 59.4 157.94 61.04 152.44 94.66 132.57 57.11 148.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.4 157.94 64.47 154.47 61.04 152.44 59.4 157.94",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.04 152.44 64.47 154.47 63.66 155.02 61.04 152.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23,160.91a.69.69,0,0,1-.48-.2.66.66,0,0,1,0-.94c.68-.63,1.36-1.23,2-1.77a.67.67,0,0,1,.93.1.66.66,0,0,1-.1.93c-.64.52-1.3,1.09-2,1.71A.66.66,0,0,1,51.23,160.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61,236.54c-1.3,0-2.59,0-3.85-.07a.66.66,0,0,1-.64-.68.67.67,0,0,1,.68-.64c1.69.06,3.41.08,5.17.06h0a.66.66,0,0,1,0,1.32Zm5.7-.14a.66.66,0,0,1,0-1.32c1.69-.08,3.43-.2,5.16-.35a.68.68,0,0,1,.72.6.66.66,0,0,1-.6.72c-1.75.15-3.51.27-5.22.35Zm-13.86-.16h0c-1.74-.13-3.5-.3-5.21-.52a.66.66,0,0,1-.57-.74.67.67,0,0,1,.74-.57c1.69.21,3.41.38,5.14.51a.66.66,0,0,1,0,1.32Zm23.36-.64a.66.66,0,0,1-.07-1.31c1.68-.2,3.4-.44,5.13-.71a.66.66,0,0,1,.2,1.31c-1.74.27-3.48.51-5.18.71ZM83,235.09h-.11c-1.75-.31-3.48-.66-5.14-1.05a.66.66,0,1,1,.3-1.28c1.64.38,3.34.73,5.06,1a.67.67,0,0,1,.54.77A.66.66,0,0,1,83,235.09ZM73.7,233a.55.55,0,0,1-.18,0c-1.7-.49-3.37-1-5-1.63a.66.66,0,0,1-.39-.85.65.65,0,0,1,.84-.39c1.59.58,3.24,1.12,4.9,1.6a.66.66,0,0,1,.45.82A.64.64,0,0,1,73.7,233Zm-9-3.22a.63.63,0,0,1-.26,0c-1.62-.71-3.21-1.48-4.73-2.28a.67.67,0,0,1-.27-.9.66.66,0,0,1,.89-.27c1.49.79,3,1.54,4.64,2.24a.66.66,0,0,1,.34.87A.67.67,0,0,1,64.73,229.73Zm-8.44-4.42a.67.67,0,0,1-.35-.1c-1.5-1-3-2-4.32-3a.66.66,0,1,1,.8-1.05c1.33,1,2.75,2,4.23,2.92a.66.66,0,0,1,.21.91A.68.68,0,0,1,56.29,225.31Zm-7.6-5.73a.65.65,0,0,1-.45-.17,46.7,46.7,0,0,1-3.71-3.74.67.67,0,0,1,.06-.94.66.66,0,0,1,.93.06,44.23,44.23,0,0,0,3.61,3.64.67.67,0,0,1,0,.94A.67.67,0,0,1,48.69,219.58Zm-6.36-7.08a.65.65,0,0,1-.54-.27A38.24,38.24,0,0,1,39,207.72a.66.66,0,0,1,1.17-.61,36.94,36.94,0,0,0,2.68,4.35.66.66,0,0,1-.54,1Zm-4.47-8.39a.66.66,0,0,1-.62-.44,27.78,27.78,0,0,1-1.09-3.82c-.1-.44-.18-.88-.25-1.32a.66.66,0,1,1,1.3-.22q.11.63.24,1.26a30,30,0,0,0,1,3.66.65.65,0,0,1-.39.84A.62.62,0,0,1,37.86,204.11Zm-1.75-9.33a.66.66,0,0,1-.66-.64c0-.42,0-.84,0-1.26a36.55,36.55,0,0,1,.22-4,.67.67,0,0,1,.73-.58A.66.66,0,0,1,37,189a33.9,33.9,0,0,0-.22,3.88c0,.4,0,.81,0,1.21a.67.67,0,0,1-.64.69Zm.93-9.47h-.15a.66.66,0,0,1-.49-.79,42.22,42.22,0,0,1,1.49-5.07.66.66,0,0,1,1.24.45,43.41,43.41,0,0,0-1.45,4.91A.65.65,0,0,1,37,185.31Zm3.13-9a.71.71,0,0,1-.28-.06.67.67,0,0,1-.32-.88c.74-1.57,1.57-3.13,2.48-4.65a.66.66,0,0,1,.91-.22.65.65,0,0,1,.22.9c-.88,1.48-1.69,3-2.41,4.53A.66.66,0,0,1,40.17,176.32ZM45,168.11a.66.66,0,0,1-.53-1.05c1-1.44,2.13-2.83,3.27-4.13a.66.66,0,1,1,1,.88c-1.11,1.26-2.18,2.62-3.19,4A.66.66,0,0,1,45,168.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3,234.16a.66.66,0,0,1-.12-1.31c.86-.16,1.72-.32,2.59-.5a.66.66,0,0,1,.26,1.3l-2.61.5Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-123"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.04 168.98 396.62 149.19 412.39 156.16 357.04 168.98",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.04 168.98 391.91 145.67 385.66 136.7 357.04 168.98",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.91 145.67 391.25 151.87 357.04 168.98 391.91 145.67",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.91 145.67 391.25 151.87 357.04 168.98 391.91 145.67",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,145.6a.66.66,0,0,1-.51-.25.66.66,0,0,1,.1-.93l.46.48.37.55A.68.68,0,0,1,397.38,145.6Zm3.34-3a.69.69,0,0,1-.46-.18.66.66,0,0,1,0-.93,26.9,26.9,0,0,0,3.2-4.05.66.66,0,0,1,1.11.72,28.94,28.94,0,0,1-3.35,4.24A.65.65,0,0,1,400.72,142.64Zm5.39-8a.66.66,0,0,1-.27-.06.65.65,0,0,1-.33-.87,31,31,0,0,0,1.75-4.87.65.65,0,0,1,.81-.46.66.66,0,0,1,.47.81,33.6,33.6,0,0,1-1.83,5.07A.66.66,0,0,1,406.11,134.64Zm2.65-9.28h-.09a.67.67,0,0,1-.57-.74,33,33,0,0,0,.3-4.47c0-.23,0-.47,0-.7a.66.66,0,0,1,.65-.68h0a.66.66,0,0,1,.66.65c0,.24,0,.49,0,.73a34,34,0,0,1-.31,4.64A.66.66,0,0,1,408.76,125.36Zm-.07-9.67a.66.66,0,0,1-.66-.56,34.53,34.53,0,0,0-1.11-5.07.66.66,0,0,1,1.27-.37,36.72,36.72,0,0,1,1.15,5.25.66.66,0,0,1-.56.75Zm-2.63-9.29a.66.66,0,0,1-.61-.4,36.62,36.62,0,0,0-2.37-4.62.66.66,0,0,1,.22-.91.66.66,0,0,1,.91.23,38.41,38.41,0,0,1,2.46,4.77.66.66,0,0,1-.35.87A.58.58,0,0,1,406.06,106.4Zm-4.9-8.34a.64.64,0,0,1-.52-.25,40.78,40.78,0,0,0-3.43-3.92.66.66,0,0,1,.94-.93,41.83,41.83,0,0,1,3.53,4,.65.65,0,0,1-.52,1.06Zm-6.73-6.93A.66.66,0,0,1,394,91c-.8-.66-1.64-1.3-2.49-1.91-.56-.4-1.13-.79-1.72-1.18a.66.66,0,1,1,.73-1.1c.6.39,1.18.79,1.76,1.21.87.62,1.73,1.28,2.56,2a.67.67,0,0,1-.42,1.18Zm-8-5.4a.61.61,0,0,1-.32-.08c-1.48-.82-3.05-1.6-4.68-2.34a.66.66,0,0,1,.54-1.2c1.66.74,3.27,1.55,4.78,2.38a.66.66,0,0,1-.32,1.24Zm-8.8-4a.68.68,0,0,1-.23,0c-1.6-.61-3.27-1.18-5-1.7a.67.67,0,0,1-.44-.83.66.66,0,0,1,.83-.43c1.72.53,3.41,1.11,5,1.73a.66.66,0,0,1,.38.85A.67.67,0,0,1,377.59,81.69Zm-9.24-2.91-.16,0c-1.66-.43-3.38-.82-5.13-1.17a.66.66,0,0,1,.26-1.29c1.77.35,3.52.75,5.2,1.18a.66.66,0,0,1-.17,1.3Zm-53.23-.12a.66.66,0,0,1-.64-.49.67.67,0,0,1,.48-.81c1.68-.43,3.43-.83,5.19-1.17a.64.64,0,0,1,.77.52.66.66,0,0,1-.52.77c-1.73.34-3.45.73-5.11,1.16A.5.5,0,0,1,315.12,78.66Zm43.73-1.82h-.1c-1.7-.26-3.45-.49-5.21-.68a.66.66,0,1,1,.14-1.31c1.78.19,3.55.42,5.27.69a.66.66,0,0,1,.56.75A.67.67,0,0,1,358.85,76.84Zm-34.24-.1a.66.66,0,0,1-.65-.56.66.66,0,0,1,.56-.75c1.72-.26,3.5-.49,5.27-.67a.66.66,0,1,1,.13,1.32c-1.75.17-3.5.39-5.21.65Zm24.61-1h-.05c-1.74-.12-3.5-.19-5.25-.23a.67.67,0,0,1-.65-.68.66.66,0,0,1,.67-.64h0c1.76,0,3.55.11,5.31.23a.66.66,0,0,1,0,1.32Zm-15,0a.65.65,0,0,1-.66-.62.67.67,0,0,1,.62-.7c1.75-.1,3.54-.17,5.31-.2h0a.66.66,0,0,1,.66.65.65.65,0,0,1-.65.67c-1.75,0-3.52.1-5.25.2Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-123"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "448.07 346.43 435.95 339.44 448.07 335.94 448.07 346.43",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "448.07 346.43 435.95 339.44 448.07 335.94 448.07 346.43"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 370.99 387.36 382.15 307.42 336.06 307.42 324.9 387.36 370.99",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 370.99 387.36 382.15 307.42 336.06 307.42 324.9 387.36 370.99"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "301.36 237.42 381.3 283.51 381.3 374.49 301.36 328.4 301.36 237.42",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.36 237.42 381.3 283.51 381.3 374.49 301.36 328.4 301.36 237.42"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "381.3 283.51 460.19 237.96 460.19 328.94 381.3 374.49 381.3 283.51",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.3 283.51 460.19 237.96 460.19 328.94 381.3 374.49 381.3 283.51",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.19 237.96 380.25 191.87 301.36 237.42 381.3 283.51 460.19 237.96",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 287.01 454.13 248.46 454.13 269.45 387.36 308.01 387.36 287.01",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 287.01 454.13 248.46 454.13 269.45 387.36 308.01 387.36 287.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 315.01 454.13 276.45 454.13 325.44 387.36 363.99 387.36 315.01",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 315.01 454.13 276.45 454.13 325.44 387.36 363.99 387.36 315.01"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "387.36 382.15 393.42 378.65 393.42 367.49 387.36 370.99 387.36 382.15",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.07 346.43 454.13 342.93 454.13 332.44 448.07 335.94 448.07 346.43",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.05,279.49c0,1,2.89.08,6.46-2L425.83,271c3.57-2.06,6.46-4.51,6.46-5.48v-1.75l-24.24,14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.13 325.44 411.99 300.78 387.36 315.01 387.36 363.99 454.13 325.44",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.43,230.62c-5.51,3.19-5.51,8.35,0,11.53s14.46,3.19,20,0,5.52-8.34,0-11.53S420,227.44,414.43,230.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,237.21c4.87-5,7.73-17.38,3-21.32H412.33c-4.74,3.94-1.89,16.34,3,21.31l.13.14.17.16a5.66,5.66,0,0,0,.44.4l.12.09.37.27a5.23,5.23,0,0,0,.63.41,16,16,0,0,0,14.5,0h0a6.29,6.29,0,0,0,.64-.41c.12-.08.23-.17.34-.26l.14-.11c.15-.12.29-.25.43-.38l.19-.19A1.14,1.14,0,0,0,433.52,237.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,214.3c-5.51,3.19-5.51,8.35,0,11.53s14.46,3.19,20,0,5.52-8.34,0-11.53S420,211.12,414.43,214.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.34,216.56c-3.35,1.94-3.35,5.08,0,7a13.41,13.41,0,0,0,12.15,0c3.36-1.93,3.36-5.07,0-7A13.41,13.41,0,0,0,418.34,216.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.49,219.89a13.41,13.41,0,0,0-12.15,0,5.67,5.67,0,0,0-2,1.84,5.58,5.58,0,0,0,2,1.84,13.41,13.41,0,0,0,12.15,0,5.42,5.42,0,0,0,2-1.84A5.5,5.5,0,0,0,430.49,219.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.5,221.62a30,30,0,0,1-4.82-6.4c-2.23-3.94-2.64-9.21-1.49-9.86S418,210,418,210a29,29,0,0,1-.49-6.72c.2-3.5,1.05-6.69,2.06-7.33s3.25,3.78,4.21,7,1.54,5.84,1.54,5.84a49,49,0,0,1,1.72-7.37c1.17-3.33,2.23-4.08,3.05-3.75s1.37,1.88,1.61,6.31a45.15,45.15,0,0,1-.2,6.34s1.65-1.82,3.48-3.58c2-1.93,2.88-2.2,3.45-1.83s.74,3.38-2.38,9a31.41,31.41,0,0,1-5.89,7.74S425.87,224.4,418.5,221.62Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418.5,221.62a30,30,0,0,1-4.82-6.4c-2.23-3.94-2.64-9.21-1.49-9.86S418,210,418,210a29,29,0,0,1-.49-6.72c.2-3.5,1.05-6.69,2.06-7.33s3.25,3.78,4.21,7,1.54,5.84,1.54,5.84a49,49,0,0,1,1.72-7.37c1.17-3.33,2.23-4.08,3.05-3.75s1.37,1.88,1.61,6.31a45.15,45.15,0,0,1-.2,6.34s1.65-1.82,3.48-3.58c2-1.93,2.88-2.2,3.45-1.83s.74,3.38-2.38,9a31.41,31.41,0,0,1-5.89,7.74S425.87,224.4,418.5,221.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M421.34,213.76s-3.13-8.28-3.32-14.29a25.9,25.9,0,0,0-.49,3.78A29,29,0,0,0,418,210S419.76,212.87,421.34,213.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27,222.78a16.31,16.31,0,0,1-6.61-2.71c-3.09-2.31-7.62-9.61-8.09-12.53a16.93,16.93,0,0,0,2.11,7.68,30,30,0,0,0,4.82,6.4A16.78,16.78,0,0,0,426.27,222.78Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-123"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "404.31 249.28 374.68 266.31 333.53 242.56 363.16 225.52 404.31 249.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,265.23l28.74-16.62a10.15,10.15,0,0,1,.13-6.27l-28.59,16.47S374.22,260.32,374.4,265.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.91,256.85a5.1,5.1,0,0,0-2.31,4v4.67c0,1.47,1,2.07,2.31,1.33l28.4-16.41v-1.16l-28.09,16.15c-.76.44-1.38.08-1.38-.8l0-4.33a3.06,3.06,0,0,1,1.39-2.4l28.06-16.16v-1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.31,240.44l-41.15-23.76-28.4,16.42a5.1,5.1,0,0,0-2.31,4v4.68a1.62,1.62,0,0,0,.68,1.49L374.28,267a1.63,1.63,0,0,1-.68-1.5v-4.67a5.13,5.13,0,0,1,2.31-4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,258.57a4.73,4.73,0,0,0-.68,2.28v4.67a1.63,1.63,0,0,0,.68,1.5l-41.15-23.76a1.62,1.62,0,0,1-.68-1.49v-4.68a4.69,4.69,0,0,1,.68-2.27Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puff--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bean-bag--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.49,171c-22.9,13.22-59.33,39.49-59.33,95.91s37.92,101.15,89,119.89c27.32,10,70.61,13.87,103.6-3,28.68-14.68,48-29.77,58.52-57.17,17.64-45.94,0-81.37-26.38-100.4s-37.12-26.21-59.6-47.49c-11.41-10.8-28.46-18.06-46.47-20.07A100.77,100.77,0,0,0,141.49,171Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.49,171c-22.9,13.22-59.33,39.49-59.33,95.91s37.92,101.15,89,119.89c27.32,10,70.61,13.87,103.6-3,28.68-14.68,48-29.77,58.52-57.17,17.64-45.94,0-81.37-26.38-100.4s-37.12-26.21-59.6-47.49c-11.41-10.8-28.46-18.06-46.47-20.07A100.77,100.77,0,0,0,141.49,171Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,359.35c-45.25-36.87-48.49-95.42-37.32-131.16,11.69-37.41,47.06-65.53,90.74-69.57h0a93.49,93.49,0,0,0-9.53-.52c-39.36,6.31-71.77,34.21-82.82,69.59-11.31,36.19-8,95.62,37.87,133,19.61,16,49.26,29.85,72.7,34.64,2.8,0,5.61,0,8.43-.09C199.25,391.19,166.79,375.13,147.42,359.35Z",
    style: {
      fill: "#FD751B",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,359.35c-45.25-36.87-48.49-95.42-37.32-131.16,11.69-37.41,47.06-65.53,90.74-69.57h0a93.49,93.49,0,0,0-9.53-.52c-39.36,6.31-71.77,34.21-82.82,69.59-11.31,36.19-8,95.62,37.87,133,19.61,16,49.26,29.85,72.7,34.64,2.8,0,5.61,0,8.43-.09C199.25,391.19,166.79,375.13,147.42,359.35Z",
    style: {
      opacity: 0.05
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8,383.47C112,371,119.14,334,107.25,324.09H46.79C34.91,334,42.06,371,54.23,383.46l.34.34c.14.14.27.28.42.41.34.33.7.66,1.1,1l.29.23c.3.23.59.47.92.69a18.08,18.08,0,0,0,1.57,1c10,5.79,26.27,5.79,36.3,0h0a18.22,18.22,0,0,0,1.58-1c.31-.22.58-.43.86-.65l.36-.28c.38-.31.73-.63,1.06-.95l.49-.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,320.12c-13.8,8-13.8,20.88,0,28.84s36.16,8,50,0,13.8-20.88,0-28.84S65.83,312.15,52,320.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67,324c-10.13,5.85-10.13,15.33,0,21.18s26.56,5.85,36.69,0,10.14-15.33,0-21.18S68.81,318.1,58.67,324Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.67,324c-10.13,5.85-10.13,15.33,0,21.18s26.56,5.85,36.69,0,10.14-15.33,0-21.18S68.81,318.1,58.67,324Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.36,334c-10.13-5.85-26.55-5.85-36.69,0a16.88,16.88,0,0,0-6.06,5.57,16.77,16.77,0,0,0,6.06,5.56c10.14,5.85,26.56,5.85,36.69,0a16.73,16.73,0,0,0,6.07-5.56A16.83,16.83,0,0,0,95.36,334Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.08,311.2a15.53,15.53,0,0,0,1.43-4.08c.62-3.4-.23-7.31-3-9.4-1.1-.84-2.53-1.46-3-2.75a4.4,4.4,0,0,1,0-2.25c.51-2.91,1.49-5.91.68-8.75a9.76,9.76,0,0,0-5.42-5.81,29.3,29.3,0,0,0-7.9-2.06,12.74,12.74,0,0,1-4.18-1.2c-1.56-.87-2-2.42-3-3.77a26.11,26.11,0,0,0-3.83-4.1c-2.85-2.54-6.42-4.64-10.36-4.46-8.22.36-8,7.44-5.62,12.8s3,7.11-2.13,12.7-5.15,12.48,1,16.34,10.12,4.37,7.69,11.79c-2.17,6.63-3.51,12.3,2.62,19.38,4,4.58,9.37,7.85,16.15,7.57a27,27,0,0,0,7.92-1.84c1.87-.93.61-2.38,1.24-4.22l4.06-11.86c1-3.06,1.85-6.46,3.23-9.35C82.4,314.25,83.31,312.76,84.08,311.2Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.08,311.2a15.53,15.53,0,0,0,1.43-4.08c.62-3.4-.23-7.31-3-9.4-1.1-.84-2.53-1.46-3-2.75a4.4,4.4,0,0,1,0-2.25c.51-2.91,1.49-5.91.68-8.75a9.76,9.76,0,0,0-5.42-5.81,29.3,29.3,0,0,0-7.9-2.06,12.74,12.74,0,0,1-4.18-1.2c-1.56-.87-2-2.42-3-3.77a26.11,26.11,0,0,0-3.83-4.1c-2.85-2.54-6.42-4.64-10.36-4.46-8.22.36-8,7.44-5.62,12.8s3,7.11-2.13,12.7-5.15,12.48,1,16.34,10.12,4.37,7.69,11.79c-2.17,6.63-3.51,12.3,2.62,19.38,4,4.58,9.37,7.85,16.15,7.57a27,27,0,0,0,7.92-1.84c1.87-.93.61-2.38,1.24-4.22l4.06-11.86c1-3.06,1.85-6.46,3.23-9.35C82.4,314.25,83.31,312.76,84.08,311.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M72.9,341.27a.61.61,0,0,1-.41-.58c.35-40.62-22-64.88-22.27-65.12a.6.6,0,0,1,0-.86.58.58,0,0,1,.85,0c.23.24,23,24.83,22.6,66a.61.61,0,0,1-.61.61A.58.58,0,0,1,72.9,341.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.38,303.49l-.12-.06c-7.29-4.59-20.29-8-20.42-8a.62.62,0,0,1-.43-.75.6.6,0,0,1,.74-.44c.54.14,13.31,3.51,20.75,8.19a.61.61,0,0,1,.19.84A.6.6,0,0,1,66.38,303.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,297.92l0,0a.6.6,0,0,1-.33-.79,47.12,47.12,0,0,1,6.72-11.31.6.6,0,0,1,.85-.07.62.62,0,0,1,.07.87,46.52,46.52,0,0,0-6.52,11A.61.61,0,0,1,64.13,297.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.61,345.67a34.14,34.14,0,0,0,17.83.66c10.24-2.21,16.5-11.77,16.5-11.77s-11.07-4.43-17.53-4.86c0,0,10-1.71,19.39.41,0,0,5.92-2.2,4.8-12.21,0,0-5.57-4.11-18.41-2.5,0,0,6.43-4.59,17.71-5.94.89,0-.32-13-1.39-18.83s-3.34-7.29-8-6.79-18.11,6-19.85,9.33,0,11.87,0,11.87a19.54,19.54,0,0,1-3.77-11.16s-5.13,1.87-7.87,4.3a18.13,18.13,0,0,0-4.91,6.14c.64,4.57,2.79,11.55,5.81,15.45,0,0-6.8-4.39-8.35-12.48,0,0-5.44,6.95-5.39,15.91C65.26,333.43,69.8,341,78.61,345.67Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.61,345.67a34.14,34.14,0,0,0,17.83.66c10.24-2.21,16.5-11.77,16.5-11.77s-11.07-4.43-17.53-4.86c0,0,10-1.71,19.39.41,0,0,5.92-2.2,4.8-12.21,0,0-5.57-4.11-18.41-2.5,0,0,6.43-4.59,17.71-5.94.89,0-.32-13-1.39-18.83s-3.34-7.29-8-6.79-18.11,6-19.85,9.33,0,11.87,0,11.87a19.54,19.54,0,0,1-3.77-11.16s-5.13,1.87-7.87,4.3a18.13,18.13,0,0,0-4.91,6.14c.64,4.57,2.79,11.55,5.81,15.45,0,0-6.8-4.39-8.35-12.48,0,0-5.44,6.95-5.39,15.91C65.26,333.43,69.8,341,78.61,345.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,344.76a.57.57,0,0,0,.37-.5c1.54-19.38,23.23-49.67,32.82-55.75a.59.59,0,0,0,.18-.81.58.58,0,0,0-.8-.18c-9.74,6.18-31.79,37-33.36,56.65a.58.58,0,0,0,.53.63A.46.46,0,0,0,77.26,344.76Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--smiley-faces--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--smiley-face--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.48,155.84c0-19.22-11.68-41.55-26.1-49.87-6.61-3.82-12.67-4.09-17.27-1.34h0l-11.22,6.63,5,10.59c0,.79-.07,1.6-.07,2.43,0,18.45,10.77,39.76,24.39,48.79l4.95,10.44L320.31,177h0C325.92,173.88,329.48,166.44,329.48,155.84Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.48,155.84c0-19.22-11.68-41.55-26.1-49.87-6.61-3.82-12.67-4.09-17.27-1.34h0l-11.22,6.63,5,10.59c0,.79-.07,1.6-.07,2.43,0,18.45,10.77,39.76,24.39,48.79l4.95,10.44L320.31,177h0C325.92,173.88,329.48,166.44,329.48,155.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.06,
    cy: 147.36,
    rx: 22.71,
    ry: 40.15,
    transform: "translate(-34.38 126.12) rotate(-23.05)",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,159.93c0,5.36-1.4,9.7-3.76,12.51-3.28,3.93-8.37,4.88-14.08,1.57S281.25,163.82,278,156.14a44.44,44.44,0,0,1-3.75-16.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,172.44c-3.28,3.93-8.37,4.88-14.08,1.57S281.25,163.82,278,156.14c3.66-2.64,8.65-2.67,14.12.47S302.5,165.53,306.16,172.44Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,151.71a1.52,1.52,0,0,1-1-.41l-9.3-8.81a1.51,1.51,0,0,1,.9-2.6l7.17-.64a1.53,1.53,0,0,1,1.64,1.37,1.51,1.51,0,0,1-1.37,1.64l-3.83.34,6.87,6.5a1.51,1.51,0,0,1-1,2.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,134.68l-.31,0-9.3-1.93a1.51,1.51,0,1,1,.62-3l5.17,1.08-4.53-5.64a1.51,1.51,0,0,1,2.36-1.89l7.17,8.92a1.52,1.52,0,0,1,.11,1.73A1.5,1.5,0,0,1,285.11,134.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.67,158.69s-1.79,6.86-9.94,10.27a1.41,1.41,0,0,0,.08,2.65,20.17,20.17,0,0,0,19.43-3.86Z",
    style: {
      fill: "#FD751B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--smiley-face--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.9,84.38c0-10.75-6.53-23.23-14.59-27.89-3.7-2.13-7.09-2.28-9.66-.74h0l-6.27,3.7,2.81,5.93c0,.44,0,.89,0,1.35,0,10.32,6,22.23,13.64,27.29l2.76,5.83,6.23-3.62h0C266.91,94.47,268.9,90.31,268.9,84.38Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9,84.38c0-10.75-6.53-23.23-14.59-27.89-3.7-2.13-7.09-2.28-9.66-.74h0l-6.27,3.7,2.81,5.93c0,.44,0,.89,0,1.35,0,10.32,6,22.23,13.64,27.29l2.76,5.83,6.23-3.62h0C266.91,94.47,268.9,90.31,268.9,84.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.98,
    cy: 79.64,
    rx: 12.7,
    ry: 22.45,
    transform: "translate(-11.38 103.46) rotate(-23.05)",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,86.67a10.81,10.81,0,0,1-2.1,7c-1.83,2.2-4.68,2.73-7.87.88s-6.06-5.69-7.89-10A24.75,24.75,0,0,1,238,75.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,93.66c-1.83,2.2-4.68,2.73-7.87.88s-6.06-5.69-7.89-10c2-1.48,4.83-1.49,7.89.26A22.15,22.15,0,0,1,255.86,93.66Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66,76.27a3.88,3.88,0,0,0,1.47,3.11c.81.47,1.47-.16,1.47-1.41a3.88,3.88,0,0,0-1.47-3.11C253.32,74.39,252.66,75,252.66,76.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,69.45a3.88,3.88,0,0,0,1.47,3.11c.81.47,1.47-.17,1.47-1.41A3.88,3.88,0,0,0,241.89,68C241.08,67.57,240.42,68.2,240.42,69.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.14,86a9.48,9.48,0,0,1-5.56,5.74.8.8,0,0,0,0,1.49A11.29,11.29,0,0,0,242.49,91Z",
    style: {
      fill: "#FD751B"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.33,259.52c-17-9.4-20.29-19.68-35-58s-42.21-26.2-42.21-26.2-51.52,15.13-59.45,39.11c-6.44,19.45,1.79,44.37,8.27,59.26a71.94,71.94,0,0,0,11.32,18.54c-19.42-3.82-34.88,9.28-34.88,9.28s16.38-7.77,43.27,3c15.92,6.39,28.33,19,45.24,24,13.13,3.85,26.44,7.74,37.26,16.5a49.94,49.94,0,0,1,18.15,31.93,19.39,19.39,0,0,0,1.45,6.3c17.11-8.83,30.83-17.87,41.3-29.67.33-3.82.09-7.74.19-11.57.38-14.09.56-28.22-.19-42.31C315.29,267.33,299.31,268.92,282.33,259.52Z",
    style: {
      fill: "#FD751B",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.33,259.52c-17-9.4-20.29-19.68-35-58s-42.21-26.2-42.21-26.2-51.52,15.13-59.45,39.11c-6.44,19.45,1.79,44.37,8.27,59.26a71.94,71.94,0,0,0,11.32,18.54c-19.42-3.82-34.88,9.28-34.88,9.28s16.38-7.77,43.27,3c15.92,6.39,28.33,19,45.24,24,13.13,3.85,26.44,7.74,37.26,16.5a49.94,49.94,0,0,1,18.15,31.93,19.39,19.39,0,0,0,1.45,6.3c17.11-8.83,30.83-17.87,41.3-29.67.33-3.82.09-7.74.19-11.57.38-14.09.56-28.22-.19-42.31C315.29,267.33,299.31,268.92,282.33,259.52Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.12,110.45a12.45,12.45,0,0,0-6.41-2.92A20.08,20.08,0,0,0,130,116.81c-3.57,6-3.73,13.38-2.56,20.22s3.54,13.43,4.71,20.27c1,6.08-5,11.65-8.93,15.45-.73.69-1.52,1.69-1.06,2.59a2.24,2.24,0,0,0,1.65.93,19.6,19.6,0,0,0,19.53-7.84l.58,5.13a9.43,9.43,0,0,0,6.23-5.32A19.63,19.63,0,0,0,151.7,160c.1-9.44-3.51-18.09-4.55-27.3-1.16-10.36,1.71-18.43,8.39-17.82,2.72.25,3.94-.78,2-3A14.52,14.52,0,0,0,156.12,110.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.4,112.2c-.45-.37-5-10.48-1.59-17.34s6.79-3,7.52,2.17A17.33,17.33,0,0,1,154.4,112.2Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,112.9c-.48.32-11.45,1.86-17.09-3.32s-1-7.36,4.18-6.61A17.33,17.33,0,0,1,156.22,112.9Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.91,362.72c-1.17,1.35-2.52,2.92-2.28,4.53a16.41,16.41,0,0,0,4.83,9c3.58,3.54,6.14,10.47,7,15.22s1.85,16.91,8.13,21.42,21.08,6.24,20.68-2.65S303.73,368,303.73,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.32,368.06a132.05,132.05,0,0,1,6.81,18.81c1.83,7.06,4.17,12,7.9,13.73s9.14,1.15,6.87-3.6-11.17-29-11.17-29Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,248.86s29.51,11.88,43.9,18.77,28.1,13.65,31.17,19.6c3.25,6.29,3.21,21.63,2.35,36.42s-2.84,41.4-2.84,41.4l-44-59.75-42.6-25.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,248.86s32.13,11.9,47.46,20.48A57.84,57.84,0,0,0,274,282.72a49.72,49.72,0,0,0-8,18.47l-37.31-17.71Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,248.86s32.13,11.9,47.46,20.48A57.84,57.84,0,0,0,274,282.72a49.72,49.72,0,0,0-8,18.47l-37.31-17.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,311.23c-4.5-9.26-13.65-15.12-22.18-19.87-6.79-3.78-23-12.13-29.62-15.57a16,16,0,0,0-.44-9.59c-1.88,8.83-3.74,11.12-3.74,11.12l43.4,29.36,31.42,50.6S301.6,320.48,297.1,311.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.94,411c-1.15.84-.85,3.78-.63,5.93s-1.21,5,2.07,8.23,8.58,3.23,13.06,7.57,11.43,12.42,23.2,12.48,19.6-5.45,21-9.24-1.13-6.59-9.2-9.21c-8.57-2.8-11-3.63-11-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,385.34s8.57,14,13.32,20.18,11.33,11.71,18.4,16.62c1.54,1.07,4.9,2.93,6.15,3.79a2.22,2.22,0,0,1,.63,3.37c-1.84,2.94-12,6.13-18.86,3.28s-14.63-9.62-19-12.22c-2.17-1.3-4.21-2.55-5.71-3.48a4.83,4.83,0,0,1-2.3-4.14c0-.48,0-1,0-1.7-.05-3.52-7.93-16-7.93-16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79,267.68c1.14,11.92,1.81,18.46,9.13,28.94,7.09,10.15,23.83,16.73,41.85,21.86,14.9,4.25,36.82,10.29,41.14,11s5.32,3,6.66,10.52,7,19,19.09,32.05a366.13,366.13,0,0,1,24.75,30.47s12-.55,16.19-8.75c0,0-37-77.1-42.76-85.93s-50.12-30.8-50.12-30.8a53.19,53.19,0,0,0,0-28.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.93,268.86c2.86,12.33,2.61,30.76,30.06,42.36,20,8.45,46.52,14.12,46.52,14.12s-4-6,.45-16.62c4.18-9.83,13-16.76,18.47-17.73l-26-13.9s5.84-11.4-.74-28.23Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.93,268.86c2.86,12.33,2.61,30.76,30.06,42.36,20,8.45,46.52,14.12,46.52,14.12s-4-6,.45-16.62c4.18-9.83,13-16.76,18.47-17.73l-26-13.9s5.84-11.4-.74-28.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4,168.16c7.51-.61,18.27.31,22.74,6,5.92,7.58,18,38.39,21.92,53.75,1.06,4.2-8.47,20.79-16.2,10.92C218.87,221,204.4,168.16,204.4,168.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65,249.24l-8.74-8.89L230,231.91l-2.52-12.4c8.13-7.3,9.71-18.86,4.78-26.86a57.53,57.53,0,0,0-12.57-14.32c-8.39-7.09-12.37-9.27-15.28-10.17-3.77.29-6.54.77-6.54.77l-21.56,5.59-9.41,4.16c5.94,6.07,8.9,17.7,7.05,28.71s-7.28,13-7.28,13l-.48,6.05s-.78,10.44,1,18.62C170,257.31,170,266.19,174,279.91c15.37,3.06,41.21-.14,56.21-11.35C244.93,257.55,243.65,249.24,243.65,249.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21,211h0l-1.71-1.3v0a1.83,1.83,0,0,0-1.68-.08l-17.33,5.86a6.49,6.49,0,0,0-3.74,3.93l-10.46,37.36a1.68,1.68,0,0,0,.35,1.85h0l1.77,1.34v0a1.83,1.83,0,0,0,1.7.09l17.33-5.85a6.52,6.52,0,0,0,3.73-3.94c2.06-7.35,8.41-30,10.46-37.36C275.9,212,275.71,211.36,275.21,211Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.38,218a6.33,6.33,0,0,0-1.88,2.82L242,258.13a1.76,1.76,0,0,0,.29,1.82l-1.66-1.26h0a1.68,1.68,0,0,1-.35-1.86l10.47-37.35a6.24,6.24,0,0,1,1.73-2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,258.13l10.46-37.35a6.51,6.51,0,0,1,3.74-3.94L273.56,211c1.61-.54,2.54.34,2.08,2-2.05,7.34-8.4,30-10.46,37.36a6.54,6.54,0,0,1-3.73,3.94l-17.33,5.85C242.51,260.65,241.58,259.76,242,258.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.26,225c3-.92,4.95,2.34,4.77,8.07s-3.44,16.37-12.3,13.8c-3.45-1-6-6.7-2.4-9.28,6.22-4.5,8.31-6.82,8.31-6.82Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,261c-3.66-7.32-10.09-25.19-12.44-43-3.18-24.09-1.71-33.74,15.45-39.37,12.74,11,9.25,38.13,9.25,38.13,2.3,10.07,6.14,27.22,8.7,33.58,16.23-.17,45.86-9.74,49.15-11.55,1.69-.93,3.55-3.67,4.63-5.12a12.87,12.87,0,0,1,4.4-4.11c2.25-1.23,4.12-2,5.73-2.86l-2.18,7.8c.19.45,1.21.54,1.69.69a28.23,28.23,0,0,0,10.73,1.2c7.56-.64,14.57-6.22,13.18.51-.55,2.67-1.59,7.7-5.56,11.14s-18.66,5.1-22.78,7.07c0,0-37.67,16.46-53.16,18.52C174.08,275.88,171,275.33,163.88,261Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,94.91a8.06,8.06,0,0,1-2.68-.08,49.15,49.15,0,0,0-10.61-1.11,37.86,37.86,0,0,0-17.34,4.14,33.07,33.07,0,0,0-17.21,23.83c-1.85,11.59,3.63,23.55,11,31.22,3.86,4,5.37,5.78,8.29,8s5.72,4,7.55,4.06l-1.1-7.59a26.26,26.26,0,0,0,13.12,1.43c4.28-.57,8.62-.46,12.47-2.64a17.29,17.29,0,0,0,8.53-11.77,20.3,20.3,0,0,1,1-4.85,16.85,16.85,0,0,1,3.39-4.3,28.77,28.77,0,0,0,7.59-18.4,10.94,10.94,0,0,0-1.14-5.93,5,5,0,0,0-5.11-2.56,22,22,0,0,0,1.92-7.28c.06-2.52-.92-5.22-3.06-6.54-1.85-1.14-4.18-1.07-6.34-.9l-.53,0q-3.28.27-6.55.75C199.82,94.55,198.77,94.79,197.73,94.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,107c4.23,1.73,10.74,8,12.66,28.65,1.59,17.13-3.29,23.16-6,24.81s-6.93,1.88-12.37,1.76l.4,7.36c14.05,8.11,18.52,19.27,6.35,19.4-15.45.16-28.78-11.95-28.94-13.31l-2.79-22.9s-4.73,3-8.81-.87c-4.37-4.1-6.3-10.65-3.4-14.61s8.59-3.25,11.66.13c0,0,7.07-.9,17.45-8.73S201.84,115.34,203.3,107Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.11,137.39l.75,8.27h0a5.9,5.9,0,0,0,5.35-6.41l-.9-9.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,124.4,207.32,123a2.62,2.62,0,0,1,3.25-2A2.85,2.85,0,0,1,212.58,124.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,148.07l10.82,1a5.21,5.21,0,0,1-5.71,5A5.7,5.7,0,0,1,193.57,148.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.11 130.28 202.49 144.63 209.23 141.73 201.11 130.28",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,162.19c-5.7.08-17.69-1.56-20.15-5.85,0,0,1,2.78,4.88,5.23s15.49,4.68,15.49,4.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,151.56A4.56,4.56,0,0,1,202.3,153a5.13,5.13,0,0,1-3.62,1A5.61,5.61,0,0,1,194.57,151.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.27,137a3.51,3.51,0,0,1,6.58-1.82,5.14,5.14,0,0,0-3.63-.34A5.21,5.21,0,0,0,190.27,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,133.64a3.51,3.51,0,0,1,6.79-.75A5.16,5.16,0,0,0,210,132,5.21,5.21,0,0,0,206.7,133.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.07,220.2c-5.57,4.71-15.29,9.05-27,3.27,0,0,5.26,7.29,14.47,6.18C214,228.28,215.07,220.2,215.07,220.2Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.59,81.54l-5.66-3.27a.52.52,0,0,1-.27-.24l-1-1.82L146,74.27l-.1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,74.55l3.92,6.79a.59.59,0,0,0,1.06-.1l4.14-12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,38.33a6.05,6.05,0,0,0-2.74-4.75L159,32.29a6.08,6.08,0,0,0-5.48,0L109.16,57.88a6,6,0,0,0-2.74,4.75V85.09a6,6,0,0,0,2.74,4.74l2.23,1.29a6,6,0,0,0,5.48,0l44.61-25.77c2.46-1.4,2.48-2.81,2.48-4.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,85.09a6,6,0,0,0,2.74,4.74l2.23,1.29a6.11,6.11,0,0,0,5,.23c-1.29.49-2.27-.25-2.27-1.81V67.08a5.5,5.5,0,0,1,.8-2.7l-7.71-4.45a5.5,5.5,0,0,0-.8,2.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.87,37.55c-.32-1.16-1.38-1.54-2.64-.81L116.86,62.33a5.54,5.54,0,0,0-1.93,2l-7.7-4.45a5.44,5.44,0,0,1,1.93-2L153.51,32.3a6.08,6.08,0,0,1,5.48,0l2.24,1.29A6,6,0,0,1,163.87,37.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.49,68.7l31.68-18.38c.92-.53,1.66-.29,1.66.54a3.32,3.32,0,0,1-1.66,2.46L121.49,71.7c-.92.53-1.66.29-1.66-.54A3.32,3.32,0,0,1,121.49,68.7Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.49,76.23l31.68-18.38c.92-.53,1.66-.29,1.66.54a3.32,3.32,0,0,1-1.66,2.46L121.49,79.22c-.92.53-1.66.29-1.66-.54A3.32,3.32,0,0,1,121.49,76.23Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.08,89.83l-5.66-3.27a.49.49,0,0,1-.27-.24l-1-1.81,3.36-2-.1.3Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.08,89.83l-5.66-3.27a.49.49,0,0,1-.27-.24l-1-1.81,3.36-2-.1.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,82.84l3.92,6.79a.59.59,0,0,0,1.06-.1l4.14-12Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.46,27a6.08,6.08,0,0,0-2.74-4.75L114.49,21A6.08,6.08,0,0,0,109,21L56.34,51.37a6.06,6.06,0,0,0-2.74,4.75V82a6.06,6.06,0,0,0,2.74,4.75L58.57,88a6.08,6.08,0,0,0,5.48,0L117,57.39c2.46-1.4,2.49-2.81,2.49-4.56Z",
    style: {
      fill: "#FD751B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,82a6.06,6.06,0,0,0,2.74,4.75L58.57,88a6.17,6.17,0,0,0,5,.23c-1.29.48-2.28-.25-2.28-1.81V60.57a5.55,5.55,0,0,1,.81-2.7l-7.71-4.45a5.52,5.52,0,0,0-.81,2.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,26.21c-.32-1.16-1.38-1.54-2.65-.81L64.05,55.82a5.54,5.54,0,0,0-1.93,2l-7.7-4.45a5.36,5.36,0,0,1,1.93-2L109,21a6.08,6.08,0,0,1,5.48,0l2.24,1.29A6,6,0,0,1,119.37,26.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,67.82,97.15,51.33c.92-.53,1.66-.29,1.66.54a3.32,3.32,0,0,1-1.66,2.46L68.68,70.82c-.92.53-1.66.29-1.66-.54A3.32,3.32,0,0,1,68.68,67.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,75.35l40-23.21c.91-.53,1.66-.29,1.66.54a3.34,3.34,0,0,1-1.66,2.46l-40,23.21c-.92.52-1.66.28-1.66-.54A3.32,3.32,0,0,1,68.68,75.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,59.93l40-23.21c.91-.53,1.66-.29,1.66.54a3.34,3.34,0,0,1-1.66,2.46l-40,23.2c-.92.53-1.66.29-1.66-.54A3.32,3.32,0,0,1,68.68,59.93Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.62d1e76b93dffb3c72ef01614b98d7ae.svg";
export { ForwardRef as ReactComponent };